import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './LogoSection.css';

const LogoSection = () => {
  const { isMarathi } = useLanguage();
  const [isHidden, setIsHidden] = useState(false);

  // Handle scroll effect for logo section
  useEffect(() => {
    let ticking = false;
    
    const getScrollThreshold = () => {
      const width = window.innerWidth;
      if (width <= 480) return 80; // Small mobile
      if (width <= 768) return 90; // Mobile
      if (width <= 1024) return 95; // Tablet
      return 100; // Desktop
    };
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const threshold = getScrollThreshold();
          // Hide logo section when navbar becomes sticky
          setIsHidden(scrollY > threshold);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  return (
    <div className={`logo-section ${isHidden ? 'hidden' : ''}`}>
      <div className="logo-section-container">
        {/* Left Section - Logo */}
        <div className="logo-left">
          <Link to="/" className="logo-link">
            <img 
              src="/logo.png" 
              alt={isMarathi() ? 'महाराष्ट्र कामगार कल्याण मंडळ' : 'Maharashtra Labour Welfare Board'}
              className="logo-image"
            />
          </Link>
        </div>

        {/* Center Section - Text */}
        <div className="logo-center">
          <h1 className="logo-title">
            {isMarathi() ? 'महाराष्ट्र कामगार कल्याण मंडळ' : 'Maharashtra Labour Welfare Board'}
          </h1>
          <p className="logo-subtitle">
            {isMarathi() ? '(महाराष्ट्र शासन)' : '(Government of Maharashtra)'}
          </p>
        </div>

        {/* Right Section - Ashok Symbol */}
        <div className="logo-right">
          <img 
            src="/ashok-symbol.png" 
            alt={isMarathi() ? 'अशोक चिन्ह' : 'Ashok Symbol'}
            className="ashok-symbol"
          />
        </div>
      </div>
    </div>
  );
};

export default LogoSection;
